import { Injectable, Injector } from '@angular/core';
import { InjectableByKey } from '@common-modules/shared/injectable-by-key/injectable-by-key.decorator';
import { PagedResultDto } from '@common-modules/shared/model/paged-result.dto';
import { ISignalTelemetryNullableViewDto } from '@common-modules/shared/model/telemetry/signal-telemetry-nullable-view.dto';
import { GridODataService } from '@common-modules/shared/odata/grid-odata.service';

@InjectableByKey({ key: 'TelemetryPointsService' })
@Injectable({ providedIn: 'root' })
export class TelemetryPointsService extends GridODataService<ISignalTelemetryNullableViewDto> {
  constructor(injector: Injector) {
    super(injector, '/api/telemetry/signal');
  }

  protected mapResponse(
    response: PagedResultDto<ISignalTelemetryNullableViewDto>
  ): PagedResultDto<ISignalTelemetryNullableViewDto> {
    return response;
  }
}
